import React from 'react'
import ClosingEntry from '../Components/OpeningEntry/ClosingEntry'

function ClosingEntryPage() {
  return (
    <ClosingEntry/>
  )
}

export default ClosingEntryPage